import React, { useState, useEffect } from "react";
import { useLanguage } from "../../hooks/useLanguage";
import { RESERVATION_GUIDE_URL } from "../../utils/urls";
import instance from "../../services/services";



function ReservationGuide(){
  const { t } = useLanguage();
  const [reservationGuide, setReservationGuide] = useState(null);

  // 유튜브 주소 체크 및 변환
  const convertYouTubeUrl = (url) => {
    if (!url) return '';
    
    // 이미 embed 형식이면 그대로 반환
    if (url.includes('youtube.com/embed/')) {
      return url;
    }
    
    let videoId;
    
    // youtu.be 형식 체크
    if (url.includes('youtu.be')) {
      videoId = url.split('youtu.be/')[1]?.split('?')[0];
    } 
    // youtube.com 형식 체크
    else if (url.includes('youtube.com')) {
      videoId = url.split('v=')[1]?.split('&')[0];
    }
    
    if (!videoId) return '';
    
    return `https://www.youtube.com/embed/${videoId}`;
  };

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const response = await instance.post(RESERVATION_GUIDE_URL, {
        });
        
        // API 응답이 배열 형태로 오므로 그대로 설정
        const guideData = response.data.data;
        setReservationGuide(guideData);

      } catch (error) {
        console.error("예약 가이드 정보 가져오기 실패:", error);
      }
    };
    fetchNotice();
  }, []);


  return(
    <section className="guide_section">

      <div>
        <h3 className="commu_title noline">{t('reservation_guide')}</h3>
        <ul className="guide_list">
          <li>
            <div className="guide_inner border_box">
              <i className="search_icon"></i>
              <p>
                {t('search_product')}<br/>
                {t('select_product')}
              </p>
            </div>
          </li>
          <li>
            <div className="guide_inner border_box">
              <i className="shopping_icon"></i>
              <p>
                {t('add_to_cart')}<br/>
                {t('add_to_cart2')}
              </p>
            </div>
          </li>
          <li>
            <div className="guide_inner border_box">
              <i className="daytime_icon"></i>
              <p>
                {t('rental_return_period')}<br/>
                {t('rental_return_period2')}
              </p>
            </div>
          </li>
          <li>
            <div className="guide_inner border_box">
              <i className="reservation_icon"></i>
              <p>
                {t('online_rental_application')}<br/>
                {t('online_rental_application2')}
              </p>
            </div>
          </li>
          <li>
            <div className="guide_inner border_box">
              <i className="complete_icon"></i>
              <p>{t('rental_application_completed2')}</p>
            </div>
          </li>
        </ul>
      </div>



      <div>
            {reservationGuide && Array.isArray(reservationGuide) && reservationGuide.length > 0 && (
              <div className="about_video_box">
                {reservationGuide.map((videoUrl, index) => {
                  const convertedUrl = convertYouTubeUrl(videoUrl);
                  if (!convertedUrl) return null;
                  
                  return (
                    <div key={index} className="video_box" style={{ marginBottom: index < reservationGuide.length - 1 ? '32px' : '0' }}>
                      <iframe
                        width="100%"
                        height="315"
                        src={convertedUrl}
                        title={`예약 가이드 동영상 ${index + 1}`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                    </div>
                  );
                })}
              </div>
            )}
      </div>




    </section>
  )
};

export default ReservationGuide;